"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AnnounceProvider: function() {
        return _AnnounceContext.AnnounceProvider;
    },
    AnnounceProvider_unstable: function() {
        return /** @deprecated Use AnnounceProvider instead. */ _AnnounceContext.AnnounceProvider;
    },
    BackgroundAppearanceProvider: function() {
        return _BackgroundAppearanceContext.BackgroundAppearanceProvider;
    },
    CustomStyleHooksContext_unstable: function() {
        return _CustomStyleHooksContext.CustomStyleHooksContext;
    },
    CustomStyleHooksProvider_unstable: function() {
        return _CustomStyleHooksContext.CustomStyleHooksProvider;
    },
    OverridesProvider_unstable: function() {
        return _OverridesContext.OverridesProvider;
    },
    PortalMountNodeProvider: function() {
        return _PortalMountNodeContext.PortalMountNodeProvider;
    },
    Provider_unstable: function() {
        return _ProviderContext.Provider;
    },
    ThemeClassNameProvider_unstable: function() {
        return _ThemeClassNameContext.ThemeClassNameProvider;
    },
    ThemeContext_unstable: function() {
        return _ThemeContext.ThemeContext;
    },
    ThemeProvider_unstable: function() {
        return _ThemeContext.ThemeProvider;
    },
    TooltipVisibilityProvider_unstable: function() {
        return _TooltipVisibilityContext.TooltipVisibilityProvider;
    },
    useAnnounce: function() {
        return _AnnounceContext.useAnnounce;
    },
    useAnnounce_unstable: function() {
        return /** @deprecated Use useAnnounce instead. */ _AnnounceContext.useAnnounce;
    },
    useBackgroundAppearance: function() {
        return _BackgroundAppearanceContext.useBackgroundAppearance;
    },
    useCustomStyleHook_unstable: function() {
        return _CustomStyleHooksContext.useCustomStyleHook;
    },
    useFluent_unstable: function() {
        return _ProviderContext.useFluent;
    },
    useOverrides_unstable: function() {
        return _OverridesContext.useOverrides;
    },
    usePortalMountNode: function() {
        return _PortalMountNodeContext.usePortalMountNode;
    },
    useThemeClassName_unstable: function() {
        return _ThemeClassNameContext.useThemeClassName;
    },
    useTooltipVisibility_unstable: function() {
        return _TooltipVisibilityContext.useTooltipVisibility;
    }
});
const _ThemeContext = require("./ThemeContext");
const _ThemeClassNameContext = require("./ThemeClassNameContext");
const _TooltipVisibilityContext = require("./TooltipVisibilityContext");
const _ProviderContext = require("./ProviderContext");
const _OverridesContext = require("./OverridesContext");
const _CustomStyleHooksContext = require("./CustomStyleHooksContext");
const _BackgroundAppearanceContext = require("./BackgroundAppearanceContext");
const _PortalMountNodeContext = require("./PortalMountNodeContext");
const _AnnounceContext = require("./AnnounceContext");
